export default {
  currencyCode(state) {
    return state.currencyCode
  },
  tenant(state) {
    return state.tenant
  },
}
